export function canStorePasswordCredential() {
  return (
    typeof window !== 'undefined' &&
    typeof window.PasswordCredential === 'function' &&
    !!navigator.credentials &&
    typeof navigator.credentials.store === 'function'
  );
}

export function waitForNextPaint() {
  if (typeof requestAnimationFrame !== 'function') {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
}

function createPasswordCredential(source) {
  if (!source || !canStorePasswordCredential()) {
    return null;
  }

  try {
    if (source instanceof window.PasswordCredential) {
      return source;
    }

    if (
      typeof HTMLFormElement !== 'undefined' &&
      source instanceof HTMLFormElement
    ) {
      try {
        return new window.PasswordCredential(source);
      } catch (err) {
        const data = new FormData(source);
        const id = data.get('username') || data.get('email');
        const password = data.get('password');
        if (id && password) {
          return new window.PasswordCredential({
            id,
            password,
            name: id,
          });
        }
        throw err;
      }
    }

    const { id, password, name } = source;
    if (!id || !password) {
      return null;
    }

    return new window.PasswordCredential({
      id,
      password,
      name: name || id,
    });
  } catch (err) {
    console.error('Error creating password credential:', err);
    return null;
  }
}

export async function storePasswordCredential(source) {
  const credential = createPasswordCredential(source);
  if (!credential) {
    return false;
  }

  try {
    await navigator.credentials.store(credential);
    return true;
  } catch (err) {
    console.error('Error storing credentials:', err);
    return false;
  }
}
